const CUSTOMER_API_PATH_PREFIX = "/apph5/customer-api/";

function parseBooleanValue(value) {
  return ["1", "true", "yes", "on"].includes(
    String(value || "").trim().toLowerCase(),
  );
}

export function isLocalCustomerBackendEnabled(
  value = process.env.LOCAL_CUSTOMER_BACKEND,
) {
  return parseBooleanValue(value);
}

export function shouldUseLocalCustomerApiProxy(
  requestUrl,
  enabled = isLocalCustomerBackendEnabled(),
) {
  return Boolean(enabled)
    && String(requestUrl || "").includes(CUSTOMER_API_PATH_PREFIX);
}
